<template>
    <div class="standard-form">
        <div class="general-title">
            <div class="title">
                Billing Details
            </div>
            <div class="buttons-container buttons">
                <a href="/billing/edit" class="neutral-bg">Update Card<span class="fa fa-credit-card"></span></a>
                <a v-if="!hasSubscription || cancelling" href="/billing/renew" class="good-bg">Renew Subscription<span class="fa fa-check"></span></a>


            </div>
        </div>
        <div v-if="hasCard" class="input-container">
            <div class="input-title">Card On File</div>
            <div class="input-box static-text">{{ card.brand }} ****{{ card.last4 }}</div>
        </div>
        <div v-if="hasSubscription && upcomingCharge" class="input-container">
            <div class="input-title">Next Bill </div>
            <div class="input-box static-text">{{ upcomingCharge.total }} on {{ upcomingCharge.date }}</div>
        </div>
        <div v-if="hasSubscription && stripeInfo.cancel_at_period_end" class="input-container">
            <div class="input-title">{{ onTrial ? 'Trial Expires On' : 'Expires On' }}</div>
            <div class="input-box static-text">{{ date(stripeInfo.current_period_end) }}</div>
        </div>
        <div v-if="hasSubscription" class="input-container">
            <div class="input-title">Change Subscription</div>
            <div class="input-box static-text">
                <a v-if="hasSubscription" href="/billing/edit">Update Subscription</a>&nbsp;&nbsp;&nbsp;
                <a v-if="hasSubscription && !cancelling" href="/billing/cancel">{{ onTrial ? 'Cancel Subscription after Trial' : 'Cancel Subscription'}}</a>
            </div>
        </div>
    </div>
</template>

<script>

import moment from 'moment';

export default {

    props: [ 'subscribed', 'subscription', 'card', 'stripeInfo', 'upcomingCharge' ],

    computed: {

        hasCard() {
            return this.card && this.card.last4;
        },

        hasSubscription() {
            return !!this.subscribed;
        },

        cancelling() {
            return !!this.stripeInfo.cancel_at_period_end;
        },

        // Subscription Statuses: trialing, active, past_due, canceled, or unpaid

        onTrial() {
            return this.hasSubscription && this.stripeInfo.status === 'trialing';
        }
    },

    methods: {

        date(unixTime) {
            return moment.unix(unixTime).format('MMMM D, YYYY');
        },
    }

}

</script>



// WEBPACK FOOTER //
// resources/js/components/billing/BillingOverview.vue